export const alertsGroupTypes = {
    FETCH_REQUEST: "ALERT_GROUP_FETCH_REQUEST",
    FETCH_SUCCESS: "ALERT_GROUP_FETCH_SUCCESS",
    CREATE_REQUEST:'CREATE_ALERT_GROUP',
    CREATE_SUCCESS:'CREATE_ALERT_GROUP_SUCCESS',
    CREATE_ERROR:'CREATE_ALERT_GROUP_ERROR',
    SET_ALERT_GROUP_USER_IDS:'SET_ALERT_GROUP_USER_IDS',
    SET_ALERT_GROUP_DETAIL:'SET_ALERT_GROUP_DETAIL',
    SET_ALERT_USER_DETAIL:'SET_ALERT_USER_DETAIL',
    SET_CURRENT_MODAL:'SET_CURRENT_MODAL',
    SET_NOTIFICATION:'SET_NOTIFICATION',
    ACTION_TYPE:'ACTION_TYPE',
    EDIT_REQUEST:'EDIT_REQUEST',
    DELETE_REQUEST:'DELETE_REQUEST',
    EXPORT_SAGA:'EXPORT_ALERT_GROUP_SAGA',
    UPDATE_FILTERS: "ALERT_GROUP_UPDATE_FILTERS",
    UPDATE_DYNAMIC_COMP: "ALERT_GROUP_UPDATE_DYNAMIC_COMP",
    SET_IS_PLAYING:"SET_IS_PLAYING",
    SET_IS_LOADING: "SET_ALERT_GROUP_IS_LOADING",
    CLEAR_FILTER: "ALERT_GROUP_CLEAR_FILTER",
    UPDATE_PAGINATION_REQUEST: "ALERT_GROUP_UPDATE_PAGINATION_REQUEST",

  };
  
  export const fetchRequest = (payload) => ({
    type: alertsGroupTypes.FETCH_REQUEST,
    payload
  });
  
  export const fetchSuccess = (resp) => ({
    type: alertsGroupTypes.FETCH_SUCCESS,
    payload: resp,
  });

  export const createAlertGroup = (data) => ({
    type: alertsGroupTypes.CREATE_REQUEST,
    payload: data,
  });

  export const createAlertGroupError = (resp) => ({
    type: alertsGroupTypes.CREATE_ERROR,
    payload: resp,
  });

  export const createAlertGroupSuccess = (resp) => ({
    type: alertsGroupTypes.CREATE_SUCCESS,
    payload: resp,
  });

  export const setAlertGroupDetail = (data) => ({
    type: alertsGroupTypes.SET_ALERT_GROUP_DETAIL,
    payload: data,
  });
  export const setAlertUserDetail = (data) => ({
    type: alertsGroupTypes.SET_ALERT_USER_DETAIL,
    payload: data,
  });

  export const setCurrentModal = (data) => ({
    type: alertsGroupTypes.SET_CURRENT_MODAL,
    payload: data,
  });

  export const setNotification = (data) => ({
    type: alertsGroupTypes.SET_NOTIFICATION,
    payload: data,
  });

  export const setActionType = (data) => ({
    type: alertsGroupTypes.ACTION_TYPE,
    payload: data,
  });

  export const editAlertGroupRequest = (data) => ({
    type: alertsGroupTypes.EDIT_REQUEST,
    payload: data,
  });

  export const deleteAlertGroupRequest = (data) => ({
    type: alertsGroupTypes.DELETE_REQUEST,
    payload: data,
  });

  export const exportAlertGroup = () => ({
    type: alertsGroupTypes.EXPORT_SAGA,
  });
  export const updatePaginationRequest = (req) => ({
      type: alertsGroupTypes.UPDATE_PAGINATION_REQUEST,
      payload: req
  });

  export const updateFilters = (resp={}) => ({
    type: alertsGroupTypes.UPDATE_FILTERS,
    payload: resp,
  });

  export const updateDynamicComp = (val)=>({
    type: alertsGroupTypes.UPDATE_DYNAMIC_COMP,
    payload: val
  })

  export const setIsPlaying = (val)=>({
    type: alertsGroupTypes.SET_IS_PLAYING,
    payload: val
  })

  export const setIsLoading = (val)=>({
    type: alertsGroupTypes.SET_IS_LOADING,
    payload: val
  })

  export const clearFilter = () => ({
    type: alertsGroupTypes.CLEAR_FILTER
  })
  